import {
  compteCourant,
  ecrireCompteCourant,
  lireEtat,
  sAbonner,
} from '@/shared/donnees/demo/magasin';
import type { EtatSession, ServiceAuth } from './types';

/**
 * L'accès libre : pas de mot de passe. On arrive directement comme bureau, et
 * l'en-tête permet de prendre n'importe quel compte pour voir l'application
 * avec ses yeux. Un compte invité depuis une fiche partenaire y figure aussitôt.
 */
function lire(): EtatSession {
  const compte = compteCourant();
  return compte ? { statut: 'connecte', utilisateur: compte } : { statut: 'anonyme' };
}

const abonnes = new Set<(etat: EtatSession) => void>();
function prevenir(): void {
  const etat = lire();
  abonnes.forEach((rappel) => {
    rappel(etat);
  });
}

/* Un compte suspendu ou rattaché ailleurs depuis l'écran Utilisateurs doit se
   refléter sur la session ouverte, comme le ferait Supabase au rechargement. */
sAbonner(prevenir);

export function prendreCompte(id: string): void {
  ecrireCompteCourant(id);
  prevenir();
}

export const serviceAuthDemo: ServiceAuth = {
  lireSession() {
    return Promise.resolve(lire());
  },
  surChangement(rappel) {
    abonnes.add(rappel);
    return () => abonnes.delete(rappel);
  },
  connexionMotDePasse(email) {
    const compte = lireEtat().comptes.find((c) => c.email === email.trim().toLowerCase());
    if (!compte)
      return Promise.resolve({ ok: false, message: 'E-mail ou mot de passe incorrect.' });
    prendreCompte(compte.id);
    return Promise.resolve({ ok: true });
  },
  envoyerLienDeConnexion() {
    return Promise.resolve({ ok: true });
  },
  demanderReinitialisation() {
    return Promise.resolve({ ok: true });
  },
  definirMotDePasse() {
    return Promise.resolve({ ok: true });
  },
  deconnexion() {
    prendreCompte('aucun');
    return Promise.resolve();
  },
};
